var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.87 28.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.87,
    height: 28.87,
    fill: "#7d3daf",
    rx: 6.48,
    ry: 6.48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.83 10.28a5.34 5.34 0 0 0-3.6-3.47 20 20 0 0 0-7.54 0A5.34 5.34 0 0 0 7 10.26a14.75 14.75 0 0 0 0 6.35 5.38 5.38 0 0 0 3.4 3.42v1.69a.68.68 0 0 0 1.17.47l1.71-1.77h1.11a20.09 20.09 0 0 0 3.77-.36 5.34 5.34 0 0 0 3.6-3.47 14.75 14.75 0 0 0 .07-6.31zm-1.35 6a4 4 0 0 1-2.54 2.44 18.66 18.66 0 0 1-4 .32.09.09 0 0 0-.07 0l-1.26 1.36-1.33 1.36a.16.16 0 0 1-.27-.11v-2.79a.1.1 0 0 0-.08-.09 4 4 0 0 1-2.54-2.44 13.38 13.38 0 0 1 0-5.74 4 4 0 0 1 2.54-2.44 18.64 18.64 0 0 1 7 0 4 4 0 0 1 2.54 2.44 13.37 13.37 0 0 1 .01 5.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.82 15.84a7.84 7.84 0 00-.65-.49c-.23-.16-.45-.32-.69-.47a.61.61 0 00-.73 0c-.22.18-.33.53-.64.57a1 1 0 01-.52-.13 3.62 3.62 0 01-2-2.25.45.45 0 010-.4.69.69 0 01.16-.17l.21-.16a.65.65 0 00.18-.88 8.08 8.08 0 00-1-1.36.5.5 0 00-.63-.15 2.34 2.34 0 00-.78.59 1 1 0 00-.3 1c.16.39.32.78.5 1.16a9.85 9.85 0 001.45 2.22 10.06 10.06 0 003.79 2.54c.14.06.29.09.44.14a2.23 2.23 0 00.4-.13 2.15 2.15 0 00.93-1 .51.51 0 00-.12-.63zM14.44 9.49h-.11a.23.23 0 00-.23.26c0 .17.2.17.34.19s.43 0 .63.07a3.35 3.35 0 012.7 2.8c0 .26.05.53.07.8s.08.26.23.26a.22.22 0 00.21-.26c0-.32 0-.64-.1-1a3.81 3.81 0 00-3.74-3.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.85 13.15a.57.57 0 0 0 0 .18.21.21 0 0 0 .4 0 .87.87 0 0 0 0-.13v-.32-.12a2.48 2.48 0 0 0-1.35-1.93 2.94 2.94 0 0 0-1.23-.32.2.2 0 0 0-.22.2.2.2 0 0 0 .19.23L15 11a2.56 2.56 0 0 1 .71.22 2.12 2.12 0 0 1 .89.83 2.27 2.27 0 0 1 .25 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.29 13a.59.59 0 0 0 0-.18 1.29 1.29 0 0 0-1.29-1.3.23.23 0 0 0-.24.18.21.21 0 0 0 .17.25c.11 0 .23 0 .35.05a.81.81 0 0 1 .25.12.84.84 0 0 1 .31.49 2.34 2.34 0 0 1 0 .3.23.23 0 0 0 .24.23.19.19 0 0 0 .21-.14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViber);
export default __webpack_public_path__ + "static/media/viber.e25c5d9a39f8b0e21a099138c10e1416.svg";
export { ForwardRef as ReactComponent };